import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";

export default function MetricCard({
  title,
  value,
  unit = "",
  color = "#000",
  animationDuration = 500,
  formatter = (val) => val,
  suffix,
  helperLines = [],
  helperText,
  helperActionLabel,
  onHelperAction,
}) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const target = typeof value === "number" ? value : Number(value) || 0;
    const duration = Math.max(animationDuration, 100);
    const steps = Math.max(Math.floor(duration / 20), 1);
    const increment = target / steps;
    const stepTime = duration / steps;
    let current = 0;

    setDisplay(0);
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setDisplay(target);
        clearInterval(timer);
      } else {
        setDisplay(current);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value, animationDuration]);

  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 2,
        borderLeft: `4px solid ${color}`,
        minHeight: 180,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" sx={{ color, fontWeight: 500 }}>
          {title}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
          <Typography variant="h3">
            {formatter(Math.round(display))}
            {unit && (
              <Typography
                component="span"
                variant="h5"
                sx={{ ml: 0.5, color: "text.secondary" }}
              >
                {unit}
              </Typography>
            )}
          </Typography>
          {suffix && (
            <Typography
              variant="h5"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              {suffix}
            </Typography>
          )}
        </Box>
        {(helperLines.length > 0 || helperText) && (
          <Box
            sx={{
              mt: 1.5,
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
            }}
          >
            {(helperLines.length
              ? helperLines
              : [
                  {
                    text: helperText,
                    actionLabel: helperActionLabel,
                    onClick: onHelperAction,
                  },
                ]
            ).map((line, idx) => (
              <Box
                key={`${title}-helper-${idx}`}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Typography variant="caption" color="text.secondary">
                  {line?.text}
                </Typography>
                {line?.actionLabel && line?.onClick && (
                  <Button
                    size="small"
                    variant="text"
                    onClick={line.onClick}
                    sx={{ textTransform: "none", p: 0, minWidth: 0 }}
                  >
                    {line.actionLabel}
                  </Button>
                )}
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
